// extracted by mini-css-extract-plugin
export default {"container":"DialogFooter--container--d1577a","fullWidth":"DialogFooter--fullWidth--67bcc6","shadow":"DialogFooter--shadow--07e3a9"};